import React from 'react';
import { History } from 'history';
import { InputDate, InputMoney, InputPicklist } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './coabalance-model';  //editable..

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class CoabalanceDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <InputDate name='balancedate' label='Date' value={this.state.datarow.balancedate} readOnly/>
                <InputMoney name='value' label='Value' value={this.state.datarow.value} readOnly/>
                <InputPicklist name='coa' label='COA' value={this.state.datarow.coa} readOnly caption={this.state.datarow.coaCaption} /> 
            </BaseDelete>
        );
    }
}